import { useEffect, useState } from "react";
export const useNotificationPermission = () => {
    const [permission, setPermission] = useState("unknown");
    useEffect(() => {
        if (typeof navigator !== "undefined" &&
            "permissions" in navigator &&
            navigator.permissions.query) {
            navigator.permissions
                .query({ name: "notifications" })
                .then((result) => {
                setPermission(result.state);
                result.onchange = () => {
                    setPermission(result.state);
                };
            });
        }
    }, []);
    return permission;
};
